import { defineMessages } from 'react-intl';
import { Tab } from '../../common/domain/mappingAudit';

export const scope = 'app.pages.MappingAuditPage';

const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Data Mapping Admin - TPICAP TCA',
  },
  metaDesc: {
    id: `${scope}.metaDesc`,
    defaultMessage:
      'Data Mapping Audit page for viewing the change history of field mappings and transformations',
  },
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Data Mapping Audit',
  },
  exportButton: {
    id: `${scope}.exportButton`,
    defaultMessage: 'Export',
  },
  ratesFieldAuditHeader: {
    id: `${scope}.ratesFieldMappingTab`,
    defaultMessage: 'Rates Field Mapping Audit',
  },
  ratesFixingProxyAuditHeader: {
    id: `${scope}.ratesFixingProxyMappingTab`,
    defaultMessage: 'Rates Fixing Proxy Mapping Audit',
  },
  LegalEntityAuditHeader: {
    id: `${scope}.LegalEntityAuditHeader`,
    defaultMessage: 'Legal Entity Mapping Audit',
  },
});

export const TAB_HEADER_MESSAGES = {
  [Tab.RATES_FIELD]: messages.ratesFieldAuditHeader,
  [Tab.RATES_FIXING]: messages.ratesFixingProxyAuditHeader,
  [Tab.LEGAL_ENTITY]: messages.LegalEntityAuditHeader,
};

export default messages;
